import { render, staticRenderFns } from "./ganttcontent.vue?vue&type=template&id=5b9ca708&"
import script from "./ganttcontent.vue?vue&type=script&lang=js&"
export * from "./ganttcontent.vue?vue&type=script&lang=js&"
import style0 from "./ganttcontent.vue?vue&type=style&index=0&id=5b9ca708&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports